import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { guaranteeItems } from '../data/content';
export function Guarantee() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-149" data-mp="223y3r2zr1zi0">
      <div className="mx-auto max-w-3xl" data-id="element-150" data-mp="1x4l9vyagns5x">
        <div className="rounded-3xl bg-white p-6 text-center shadow-sm ring-1 ring-brand-100 sm:p-10" data-id="element-151" data-mp="1x4uz3jnolvak">
          <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-4 border-gold bg-gold-light text-gold-dark" data-id="element-152" data-mp="19fad0rw8ehx2">
            <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-153" data-mp="1j4aimu58obk8" />
            <span className="mt-0.5 text-xs font-extrabold uppercase" data-id="element-154" data-mp="1j6n3pg6an21i">7 days</span>
          </div>
          <p className="mt-5 text-sm font-bold uppercase tracking-wider text-brand-600" data-id="element-155" data-mp="1ebr5fyagrify">7-day guarantee</p>
          <h2 id="guarantee-title" className="mt-2 font-serif text-[30px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-156" data-mp="qlwrfdeernu4">
            Try the Apometry Practice Deck™ for 7 days
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[17px] leading-relaxed text-muted" data-id="element-157" data-mp="oxf780y3m9oc">
            I want you to be able to explore the system before deciding whether it fits your practice. During your
            guarantee period, you can:
          </p>
          <ul className="mx-auto mt-6 grid max-w-lg gap-2 text-left sm:grid-cols-2" data-id="element-158" data-mp="12pv74svpdrl1">
            {guaranteeItems.map(item => <li key={item} className="flex items-start gap-2 text-[15px] font-medium text-ink/85" data-id="element-159" data-mp="62i3srez0whi">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-160" data-mp="b1uqnc5ue3k3" />
                {item}
              </li>)}
          </ul>
          <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-muted" data-id="element-161" data-mp="k1hsfz2hhbdo">
            If, after exploring the material, you decide the Apometry Practice Deck™ isn’t right for you, you can request
            a refund within the applicable guarantee period.
          </p>
        </div>

        <SectionCta label="I want to try it risk-free" data-id="element-162" data-mp="3rhp18bziol8x" />
      </div>
    </section>;
}